import { Point } from './point'
import * as glMatrix from 'gl-matrix'

export function fromRotation(theta: number): glMatrix.mat2d {
  const mat = glMatrix.mat2d.create()
  return glMatrix.mat2d.fromRotation(mat, theta)
}

export function fromTranslate(p: Point): glMatrix.mat2d {
  return glMatrix.mat2d.fromValues(1, 0, 0, 1, p.x, p.y)
}

export class Transform {
  protected readonly vIn: glMatrix.vec2
  protected readonly vOut: glMatrix.vec2

  /**
   * glMatrix.mat2d is a short form for the 3x3 matrix:
   * ```text
   * [a, b, 0,
   *  c, d, 0,
   *  tx, ty, 1]
   * ```
   */
  constructor() {
    this.vIn = glMatrix.vec2.create()
    this.vOut = glMatrix.vec2.create()
  }

  convert(p: Point, m: glMatrix.mat2d): Point {
    glMatrix.vec2.set(this.vIn, p.x, p.y)
    glMatrix.vec2.transformMat2d(this.vOut, this.vIn, m)

    return new Point(this.vOut[0], this.vOut[1])
  }
}
